import { useMemo } from "react";
import { useSwingListCollections } from "../../swing_library/hooks/useSwingListCollections";
import { aggregateIndicatorMetrics } from "../../swing_library/utils/metrics";

export function useCollectionMetrics(collection) {
  const videoIds = collection?.videoIds ?? [];

  const query = useSwingListCollections({
    enabled: Boolean(videoIds?.length),
    videoIds,
  });

  const videos = useMemo(
    () => query?.data?.videos ?? [],
    [query?.data?.videos]
  );

  const metrics = useMemo(() => aggregateIndicatorMetrics(videos), [videos]);

  return {
    isFetching: query.isFetching,
    isLoading: query.isLoading,
    metrics,
    videos,
  };
}
